import { useEffect } from "react";
import AgentStatusSelect from "../call-screens/AgentStatusSelect";
import WebOrPhoneModeSelectComponent from "../call-screens/WebOrPhoneStatusSelect";

export const VoiceAgentStatusSelectMenu = (props) => {
  let { setShowOfflineMessageWhileInit, restrictAccess, setRestrictAccess, isVoiceUser, voiceIntegId, isFromHeader } = props;

  useEffect(() => {
    if (isVoiceUser !== undefined && !isVoiceUser) {
      setRestrictAccess(true);
    } else {
      setRestrictAccess(false);
    }
  }, [isVoiceUser]);

  return (
    <>
      <div className="d-flex justify-content-between w-100">
        <div className="w-50 d-flex flex-row cursor-default justify-content-start" onClick={(e) => e.stopPropagation()}>
          <WebOrPhoneModeSelectComponent
            voiceIntegId={voiceIntegId}
            classNameProps={isFromHeader ? "dialPadSelectors-header" : "dialPadSelectors"}
            expandIcon={isFromHeader ? "voice-agent-status-selection-menu-icon" : "agentStatusDropDownIcon"}
            setShowOfflineMessageWhileInit={setShowOfflineMessageWhileInit}
            isFromHeader={isFromHeader}
            restrictAccess={restrictAccess}
          />
        </div>
        <div className="w-50 d-flex flex-row justify-content-end" onClick={(e) => e.stopPropagation()}>
          <AgentStatusSelect
            classNameProps={isFromHeader ? "dialPadSelectors-header" : "dialPadSelectors"}
            expandIcon={isFromHeader ? "voice-agent-status-selection-menu-icon" : "agentStatusDropDownIcon"}
            setShowOfflineMessageWhileInit={setShowOfflineMessageWhileInit}
            restrictAccess={restrictAccess}
            isFromHeader={isFromHeader}
          />
        </div>
      </div>
    </>
  );
};
